import styled from "styled-components";

export const LogoWrapper = styled.div<{marginRight?: number}>`
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
  margin-right: ${({ marginRight }) => (marginRight || `${marginRight}px`)};
`;
